<template>
    <section class="content-area-wrapper">
        <div class="sidebar-left">
            <div class="sidebar">
                <div class="sidebar-content" :class="{ 'show': showChat }">
                    <span @click="showChat = !showChat" class="sidebar-close-icon">
                        <vue-feather type="x" size="14" />
                    </span>
                    <div class="chat-fixed-search" v-if="!messageStore.chats.isLoading && userInfo && !userInfo.isClient && !client">
                        <div class="d-flex align-items-center w-100">
                            <div class="input-group input-group-merge w-100">
                                <div class="input-group-prepend">
                                    <span class="input-group-text round">
                                        <vue-feather type="search" class="text-muted" size="14" />
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    v-model="messageStore.searchValue"
                                    class="form-control round"
                                    placeholder="Search Client"
                                    aria-label="Search..."
                                    aria-describedby="chat-search"
                                    @click="messageStore.newConversation()"
                                    data-toggle="modal" data-target="#compose-message-modal"
                                />
                                <!-- @keyup="fetchChatsDebounced" -->
                                <div class="input-group-append" @click="messageStore.newConversation()" data-toggle="modal" data-target="#compose-message-modal">
                                    <span class="input-group-text round">
                                        <vue-feather type="plus-circle" class="text-primary" size="14" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top:10px; padding:5px" v-else>
                        <template v-if="!messageStore.chats.isLoading && messageStore.chats.data.length == 0">
                            <button
                                id="create-2"
                                type="button"
                                class="btn btn-primary mx-auto w-100"
                                :key="messageStore.sendButtonKey"
                                @click="messageStore.newConversation();messageStore.startMessaging(userStore.user?.id,userStore.user?.owner?.id,true)"
                                style="border-radius:50px"
                            >
                                <vue-feather type="mail" class="d-lg-none" size="14" />
                                <span class="d-none d-lg-block">
                                    Start Conversation
                                </span>
                            </button>
                        </template>

                    </div>
                    <div id="chat-list" class="chat-user-list-wrapper list-group">
                        <h4 class="chat-list-title">Messages</h4>
                        <ul class="chat-users-list chat-list media-list" >
                            <li
                                v-if="messageStore.chats.data.length > 0"
                                v-for="chat in messageStore.chats.data"
                                @click="
                                    messageStore.conversations.data = [];
                                    Object.assign(messageStore.activeChat, chat);
                                    messageStore.message = null;
                                    messageStore.conversation();
                                    showChat = false;
                                    chat.users[0].unread = 0
                                    messageStore.updateRead(userInfo)
                                "
                                class="chat-contact-list-item"
                                :class="{ 'text-active': (messageStore.activeChat.id == chat.id && messageStore.activeChat.id !== true)}"
                                style="padding: 0.5rem 0.75rem;margin: 0.25rem 0.75rem;border-radius: 0.375rem;"
                            >
                                <a class="d-flex align-items-center" style="width:100%" v-if="chat.room_type == messageStore.BUSINESS_CLIENT && chat.users && chat.users[0]">
                                    <div class="flex-shrink-0 avatar avatar-online mr-1" style="width: 42px; position: relative; background: white;margin-right: 10px;">
                                        <div
                                        v-if="chat.users[0].unread"
                                            style="position: absolute;
                                            height: 20px;
                                            width: 20px;
                                            z-index: 1000;
                                            background: red;
                                            border-radius: 100%;
                                            left: 26px;
                                            font-size: 8px;
                                            top: 0px;"
                                        >
                                            <p>{{chat.users[0].unread}}</p>
                                        </div>
                                        <p class="text-primary" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);">{{abbreviateName(chat.users[0].room_user)}}</p>
                                    </div>
                                    <div class="chat-contact-info flex-grow-1 ms-2">
                                        <h6 class="chat-contact-name text-truncate m-0" style="text-transform: capitalize;">{{ chat.users[0].room_user }}
                                            <small v-if="chat.users[0].last_conversation" class="text-muted mb-auto" style="
                                                float: right;
                                                color:white;
                                            ">{{formatDate(chat.users[0].last_conversation.created_at, 'LL')}}</small></h6>
                                            <div class="d-flex align-items-center">
                                                <p class="chat-contact-status text-muted text-truncate mb-0" v-if="chat.users[0].last_conversation"
                                                    style="
                                                    color:white;
                                                    white-space: nowrap;
                                                    text-overflow: ellipsis;
                                                    width: 200px;
                                                    "
                                                >{{ chat.users[0].last_conversation.message }}</p>
                                                <!-- <div v-if="messageStore.activeChat.id == chat.id && (userInfo && !userInfo.isClient && !client)" class="d-flex align-items-center action" style="color:white;">
                                                    <vue-feather @click="messageStore.deleteChat(chat)" type="trash-2" size="14" />
                                                </div> -->
                                            </div>
                                    </div>

                                </a>
                            </li>
                            <li v-else>
                                <h6 v-if="messageStore.chats.isLoading == false" class="mb-0">No Chats Found</h6>
                            </li>
                            <li v-if="messageStore.chats.isLoading" class="align-items-center justify-content-center">
                                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                <span class="ml-25 align-middle">Loading...</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="body-content"></div>
        <div class="content-right">
            <div class="content-wrapper">
                <div class="content-body">
                    <div class="chat-app-window">
                        <div v-show="!messageStore.activeChat.id" class="start-chat-area">
                            <header class="chat-header w-100 p-50 bg-white d-block d-lg-none">
                                <div @click="showChat = !showChat" class="sidebar-toggle">
                                    <vue-feather type="menu" class="font-medium-5" size="14" />
                                </div>
                            </header>
                            <div class="row match-height px-1 w-sm-100 w-50 my-auto">
                                <div class="col-12">
                                    <h3 class="text-primary text-center mb-1">Resume from where you stopped.</h3>
                                    <p class="text-center">Choose a conversation and start chatting.</p>
                                    <div class="user-chats"></div>
                                </div>
                            </div>

                        </div>
                        <!-- to check again -->
                        <div v-show="messageStore.activeChat.id" class="active-chat">
                            <div class="chat-navbar">
                                <header class="chat-header">
                                    <div class="d-flex align-items-center">
                                        <div class="sidebar-toggle d-block d-lg-none mr-1" @click="showChat = !showChat">
                                            <vue-feather type="menu" class="font-medium-5" size="14" />
                                        </div>
                                        <div class="avatar avatar-border m-0 mr-1" v-if="messageStore.activeChat.length > 0">
                                            {{abbreviateName(messageStore.activeChat.users[0].room_user)}}
                                        </div>
                                        <h6 class="mb-0" v-if="messageStore.activeChat.name">
                                            {{messageStore.activeChat.users[0].room_user}}
                                        </h6>

                                    </div>
                                    <!-- <div class="dropdown">
                                        <a class="btn dropdown-toggle mt-1" type="button" data-toggle="dropdown">
                                            <vue-feather type="more-horizontal" class="font-medium-5" size="24" />
                                        </a>
                                        <ul class="dropdown-menu">
                                          <li><a href="#" @click="messageStore.deleteChat(messageStore.activeChat)">Delete</a></li>
                                        </ul>
                                      </div> -->
                                </header>
                            </div>
                            <!--end to check again -->

                            <div id="user-conversation" class="user-chats">

                                <div class="chats">
                                    <div v-if="messageStore.conversations.isLoading" class="d-flex align-items-center justify-content-center">
                                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                        <span class="ml-25 align-middle">Loading...</span>
                                    </div>

                                    <!-- v-if="messageStore.conversations.data.length > 0" -->
                                    <div

                                        v-for="conversation in messageStore.conversations.data.data"
                                        class="chat"
                                        :class="{ 'chat-left': conversation.receiver_id == userInfo.id ||  (userInfo.isTeamMember && userInfo.teams && conversation.receiver_id == userInfo.teams[0].admin.id) }"
                                    >
                                        <div class="chat-avatar" style="position: relative;height: 40px;width: 40px;backround: white;">
                                            <span class="avatar box-shadow-1 cursor-pointer" style="width: 100%;height: 100%; background: white;/">
                                                <p class="text-primary" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">{{ abbreviateName(conversation.room_name) }}</p>
                                            </span>
                                        </div>

                                        <div class="chat-body">
                                            <small  class="text-muted" :class="{ 'float-left': conversation.receiver_id == userInfo.id,'float-right': conversation.receiver_id != userInfo.id }">
                                                {{ formatDate(conversation.created_at, 'LLL') }}
                                            </small>
                                            <div class="chat-content">
                                                <p>
                                                    {{ conversation.message }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="chat-app-form" action="javascript:void(0);">
                                <div class="input-group input-group-merge form-send-message">
                                    <input v-model="messageStore.message" type="text" class="form-control message" placeholder="Type your message" style="border-radius:50px" @keyup.enter="messageStore.sendMessage()"/>
                                </div>
                                <button
                                    id="create-2"
                                    type="button"
                                    class="btn btn-primary mx-1"
                                    :key="messageStore.sendButtonKey"
                                    @click="messageStore.sendMessage()"
                                    style="border-radius:50px"
                                >

                                    <template v-if="messageStore.isSending">
                                        <span class="spinner-border spinner-border-sm mr-50" role="status" aria-hidden="true"></span>
                                        <span>Sending...</span>
                                    </template>
                                    <template v-else>
                                        <vue-feather type="send" class="d-lg-none" size="14" />
                                        <span class="d-none d-lg-block">
                                            Send
                                        </span>
                                    </template>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <compose-message v-if="messageStore.activeChat.id" :id="messageStore.updateMessageModalId"/>
    </section>

</template>
<script>
    import { ref, reactive, computed, onUpdated, watch, onMounted, onUnmounted } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import moment from 'moment';
    import { useMessageStore } from '../../stores/MessageStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js';
    import { usePlanStore } from '../../stores/PlanStore.js'
    import { useSettingStore } from '../../stores/SettingStore.js'
    import Swal from 'sweetalert2'
    import { openModal, hideModal, centToDollar, formatDate,debounce } from '../../utilities/_helpers'
    import { fix, add } from 'mathjs'
    import PerfectScrollbar from 'perfect-scrollbar';
    import PaymentModal from '../modals/PaymentComponent'
    import ComposeMessage from './ComposeMessage.vue';
    import Clipboard from 'clipboard';
    import { BPopover } from 'bootstrap-vue-3'
    export default {
        name: 'Chat',
        props:{
            client:String
        },
        components: {
            PaymentModal,
            ComposeMessage,
            BPopover,
        },
        setup(props) {
            const route=useRoute(),
            router= useRouter(),
            messageStore = useMessageStore();
            const fetchChatsDebounced = debounce(() => {
                const isSearch = true; // Replace this with your actual isSearch logic
                const route = router.resolve(
                    {
                        name: 'rooms',
                    }
                );
                // Your actual fetchChats logic here...
                messageStore.fetchChats(route.href,true);
            }, 1000);

            return {
                moment: moment,
                centToDollar: centToDollar,
                formatDate: formatDate,
                messageStore: messageStore,
                userStore: useUserStore(),
                localizationStore: useLocalizationStore(),
                planStore: usePlanStore(),
                settingStore: useSettingStore(),
                openModal: openModal,
                hideModal: hideModal,
                showChat: ref(false),
                topUpType: ref(null),
                userInfo:reactive({}),
                client:props.client,
                debounce:debounce,
                route:route,
                router:router,
                fetchChatsDebounced
            }
        },
        mounted() {
            this.messageStore.activeChat = [];
            this.messageStore.activeChat = [];
            if(_.includes(['client-messages'], this.$route.name)){
                if(_.isEmpty(this.userStore.profile.user)){
                    this.userStore.fetchUserProfile();
                }{
                    this.userInfo = this.userStore.profile.user
                }
            }else{
                if(_.includes(['report'], this.$route.name)){
                    if(_.isEmpty(this.userStore.profile.user)){
                        this.userStore.fetchUserProfile();
                    }{
                        this.userInfo = this.userStore.profile.user
                    }
                }else{
                    if(_.isEmpty(this.userStore.user)){
                        this.userStore.fetchUser();
                    }{
                        this.userStore.fetchUser();
                        this.userInfo = this.userStore.user
                    }
                }

            }
            if(_.includes(['client-messages','messages'], this.$route.name)){
                this.messageStore.newMessages = false;
            }
            const $this = this;
            let route;

            if(!_.isNull($this.client)){
                route = $this.$router.resolve(
                    {
                        name: 'rooms',
                        params:{
                            client : this.client
                        }
                    }
                );
            }else{
                route = $this.$router.resolve(
                    {
                        name: 'rooms'
                    }
                );
            }
            $this.messageStore.chats.data.length = 0;
            $this.messageStore.psChat = new PerfectScrollbar('.chat-user-list-wrapper');
            $this.messageStore.psConversation = new PerfectScrollbar('#user-conversation');
            document.getElementById("chat-list").addEventListener('ps-y-reach-end', function () {
                if (
                    ($this.messageStore.chats.isLoading == false)
                    &&
                    !_.isNull($this.messageStore.chats.next_page_url)
                ) {
                    $this.messageStore.fetchChats($this.messageStore.chats.next_page_url);
                }
            });

            if ($this.messageStore.chats.isLoading == false) {
                $this.messageStore.fetchChats(route.href);
            }
            console.log(this.userStore.user)
        },
        watch: {
            'messageStore.chats.title' (newTitle, oldTitle) {
                let route;
                if(!_.isEmpty($this.client)){
                    route = $this.$router.resolve(
                        {
                            name: 'rooms',
                            params:{
                                client : this.client
                            }
                        }
                    );
                }else{
                    route = $this.$router.resolve(
                        {
                            name: 'rooms'
                        }
                    );
                }
                let isSearch = true;
                this.messageStore.fetchChats(route.href, isSearch);
            },
            'messageStore.conversations'(value){
                document.getElementById("user-conversation").addEventListener('ps-y-reach-start', function () {
                        if (
                            (value.isLoading == false)
                            &&
                            !_.isNull(value.next_page_url)
                        ) {
                            $this.conversation(value.next_page_url);
                        }
                });
            },
            'userStore.profile'(value){
                if(_.includes(['client-messages'], this.$route.name)){
                    this.userInfo = value.user
                }else{
                    if(_.includes(['report'], this.$route.name)){
                        if(_.isEmpty(this.userStore.profile.user)){
                            this.userStore.fetchUserProfile();
                        }{
                            this.userInfo = this.userStore.profile.user
                        }
                    }else{
                        if(_.isEmpty(this.userStore.user)){
                            this.userStore.fetchUser();
                        }{
                            this.userStore.fetchUser();
                            this.userInfo = this.userStore.user
                        }
                    }
                }
            },
            'userStore.user'(value){
                if(_.includes(['client-messages'], this.$route.name)){
                    this.userInfo = this.userStore.user.profile
                }else{
                    this.userInfo = value
                }
            }
        },
        methods: {
            abbreviateName(fullname){
                return fullname.replace(/\b(\w)\w+/g, '$1.').replace(/\s/g, '').replace(/\.$/, '').toUpperCase();
            }
        },

    }
</script>
<style>
.text-active{
    background-image: linear-gradient(80deg, #1f9d57, #1f9d57) !important;
    background-repeat: repeat-x;
}
.text-active h6{
    color: #fff;
}
.float-left{
    float: left;
    margin-left: 1rem;
}
.float-right{
    float: right;
    margin-right: 1rem;
}
.w-100{
    width:100% !important;
}
/**.user-chats {
        height: 300px;
}*/

  /* Webkit-based browsers (Chrome, Safari) */
  /* Note: These styles will be applied only to webkit-based browsers */
  ::-webkit-scrollbar {
    width: 8px; /* Width of the scrollbar */
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888; /* Color of the scrollbar thumb */
    border-radius: 4px; /* Rounded corners for the thumb */
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* Color of the scrollbar thumb on hover */
  }
  .new-message{
    display:none;
    position: absolute;
    width: 12px;
    height: 12px;
    background: #ea5455;
    border-radius: 100%;
    top: 10px;
    left: 27px;
  }
  /* Firefox */
  /* Note: These styles will be applied only to Firefox */
  /* Firefox supports scrollbar-color property for styling the scrollbar */
  /* The first color is the thumb color, and the second is the track color */
  /* You can adjust the colors to your liking */
  .user-chats {
    scrollbar-color: #888 #eee;
  }

  /* Optional: Hide the scrollbar when it's not being interacted with (for both webkit and firefox) */
  .user-chats::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  .user-chats:hover::-webkit-scrollbar-thumb {
    background-color: #888;
  }

  .user-chats::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }

  /* Optional: Show a custom background when the scrollbar is dragged (for webkit only) */
  .user-chats::-webkit-scrollbar-thumb:active {
    background-color: #333;
  }
</style>
